// extracted by mini-css-extract-plugin
module.exports = {"Truck__Container":"TruckRequest_Truck__Container__3MElf"};